module.exports = __webpack_public_path__ + "img/clip-payment-options.cda3f069.png";